import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { leaves } from "~/constants";
import PlanPaymentPage from "~/PlanDetailsApp/pages/PlanPaymentPage";
import PlanSelectPage from "~/PlanDetailsApp/pages/PlanSelectPage";
import { Protector } from "./Protector";
import { rrPath } from "./utils";

export const PlanDetailsRoutes: FC = () => {
  return (
    <Routes>
      <Route
        path={rrPath(leaves.planPayment)}
        element={
          <Protector requireAuth requireOnboarding protectPayment>
            <PlanPaymentPage />
          </Protector>
        }
      />
      <Route
        path={rrPath(leaves.planSelect)}
        element={
          <Protector requireAuth requireOnboarding requireNoPause>
            <PlanSelectPage />
          </Protector>
        }
      />
    </Routes>
  );
};
